// 搭配 arr.filter 使用，确保返回正确的类型
export function isDefined<T>(
  value: T | null | undefined
): value is NonNullable<T> {
  return value !== null && value !== undefined;
}
